/**
 * Scroll-to-top functionality
 * 
 * @author jjarolim
 */

const $ = window.jQuery // Use global WP jQuery instance

const SCROLL_TO_TOP_THRESHOLD = 100

const update = () => {

    // Scroll-to-top nur anzeigen, wenn 
    // der Inhalt größer als der Bildschirm ist

    const isScrollPositionTop = $(window).scrollTop() < SCROLL_TO_TOP_THRESHOLD
    const isShowScrolltoTop = $("body").height() > $(window).height()

    $(".scroll-to-top").toggle( isShowScrolltoTop && !isScrollPositionTop );

}

const debounce = (func, timeout = 50) =>{
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

const init = () => {

    // Set Click-Handler

    $(".scroll-to-top").on( 'click', () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    })

    // Update on Scroll

    $(window).on( 'scroll', debounce( update ) )

    // Update on Resize

    $(window).on( 'resize', debounce( update ) )

    // Initial Update

    update()

}

export { init }